import React from "react";
import { Button, Form, Input, Radio } from "antd";
import { useTranslation } from "react-i18next";
import Validator from "../../../../../utils/formValidator";

const PromotionRender = ({ submitting, promotionType, handlePromotionType, handleApplyPromotion }) => {
  const { t } = useTranslation(["personalCenterSetting", "common"]);
  return (
    <div className="promotion">
      <h4 className="fw-bold mb-4">{t("promotionModalTitle")}</h4>
      <Radio.Group value={promotionType} className="mb-3" onChange={handlePromotionType}>
        <Radio.Button value="promoItem">{t("promoItem")}</Radio.Button>
        <Radio.Button value="discount">{t("discount")}</Radio.Button>
      </Radio.Group>
      <Form className="mb-5" name="code-form" onFinish={handleApplyPromotion} validateTrigger="onBlur">
        <Form.Item
          label=""
          name="code"
          rules={[
            {
              required: true,
              validator: Validator.emptyValidator,
            },
          ]}
        >
          <Input placeholder={t("promoCode")} />
        </Form.Item>
        <Form.Item label="" name="code">
          <Button type="primary" className="fw-bolder" htmlType="submit" loading={submitting}>
            {t("applyBtn")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default PromotionRender;
